// @flow
import React from 'react';
import MarkdownRender from 'components/common/MarkdownRender';
import './BannerContent.scss';

type Props = {
  body: string,
  theme: string,
  thumbnail: ?string,
  onSetToc: (toc: any) => void,
  onActivateHeading: (headingId: string) => void,
};

const BannerContent = ({ body, onSetToc, onActivateHeading, thumbnail, theme }: Props) => (
  <div className="BannerContent">
    <div className="banner-info">
      {thumbnail && (
        <div className="banner-thumbnail">
          <img src={thumbnail} alt="banner-thumbnail" />
        </div>
      )}
    </div>
    <div className="contents">
      <MarkdownRender
        body={body}
        onSetToc={onSetToc}
        onActivateHeading={onActivateHeading}
        theme={theme || 'github'}
      />
    </div>
  </div>
);

BannerContent.Placeholder = () => (
  <div className="BannerContent placeholder">
    <div className="banner-thumbnail">
      <div className="fake-img" />
    </div>
    <div className="contents">
      <div className="gray-block" />
      <div className="gray-block" />
      <div className="gray-block" style={{ width: '75%' }} />
      <div className="line-breaker" />
      <div className="gray-block" />
      <div className="gray-block" style={{ width: '40%' }} />
      <div className="line-breaker" />
      <div className="gray-block" />
      <div className="gray-block" />
      <div className="gray-block" />
      <div className="gray-block" style={{ width: '40%' }} />
    </div>
  </div>
);

export default BannerContent;



// WEBPACK FOOTER //
// ./src/components/banner/BannerContent/BannerContent.js